import React from "react";

/** Remap CMS H1 styles to H2 so pages keep a single document-level H1. */
export const demoteH1Components = {
  block: {
    h1: ({ children }) => <h2>{children}</h2>,
  },
};

export const withDemotedH1 = (components = {}) => ({
  ...components,
  block: {
    ...demoteH1Components.block,
    ...(components.block ?? {}),
  },
});
